@if (isMobile) {
  <app-mobile-demo />
} @else {
  <app-demo-hero />

  <app-scene-showcase />

  <app-full-evrn-demo />

  <app-any-image-works />

  <app-demo-cost-or-complexity />

  <app-demo-evrn-method />

  <app-evrn-image-scene />

  <app-cta-panel />
}
